import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  first_name: string;
  last_name: string;
}

@Component({
    selector: 'app-logged-dialog',
    templateUrl: './logged-dialog.component.html',
    styleUrls: ['../dialog.component.scss'],
    standalone: false
})
export class LoggedDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LoggedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
